<template>
  <div class="page">
    <Header />
    <div class="header-row"></div>
    <div class="content-header"></div>
    <div class="home-content">
      <div class="content-wrapper">
        <el-row>
          <el-col :span="7" class="content-left home-content-left">
            <el-card>
              <div class="card-title">
                <span>管理台</span>
              </div>
              <div class="card-user">
                <div class="user-pic">
                  <img :src="avatarUrl" />
                </div>
                <div class="user-info">
                  <div class="user-name">
                    <span>欢迎您</span>
                    <span style="font-weight: bold; padding-left: 6px">
                      {{ userName }}
                    </span>
                  </div>
                  <div>
                    <router-link to="/user/index" class="user-opera">管理账户信息</router-link>
                  </div>
                </div>
              </div>
              <div class="card-text">
                <div class="text-title">
                  <i class="iconfont iconzu31" />
                  <span @click="toNotice" class="cursor">通知公告</span>
                </div>
                <div v-for="item in noticeList" :key="item.noticeId" class="notice-title" @click="viewNotice(item)" :title="item.noticeTitle">
                  <i class="iconfont icondian" />
                  <span>{{ item.noticeTitle }}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="17" class="content-right">
            <div class="content-right-row">
              <template v-if="!isBccProduct && !isAdmin">
                <el-card v-if="employeeLevel !== 85" shadow="hover" @click.native="handlePocm('/material/index')">
                  <div class="card-icon card-icon-1">
                    <i class="iconfont iconzu" />
                  </div>
                  <div class="card-text">POCM订购</div>
                </el-card>

                <div @click="toTradeIndex" class="router-link-block" v-if="employeeLevel >= 40 && employeeLevel !== 85">
                  <el-card shadow="hover" :class="{ 'card-disabled': employeeLevel < 40 || employeeLevel == 85 }">
                    <div class="card-icon card-icon-3">
                      <i class="iconfont iconzu2" />
                    </div>
                    <div class="card-text">渠道项目</div>
                  </el-card>
                </div>

                <el-card v-if="employeeLevel !== 85" style="margin-right: 15px" shadow="hover" @click.native="leadToCoolerPlus">
                  <div class="card-icon card-icon-2">
                    <i class="iconfont iconzu1" />
                  </div>
                  <div class="card-text">资产管理</div>
                </el-card>

                <el-card shadow="hover" @click.native="handleIcircle" v-if="canIcircle">
                  <div class="card-icon card-icon-3">
                    <img style="width: 100%; height: 100%" src="../assets/images/icircle.png" />
                  </div>
                  <div class="card-text">尊享先锋项目</div>
                </el-card>
                <template v-if="employeeLevel !== 85">
                  <el-card shadow="hover" @click.native="handlePocm('/order/index')">
                    <div class="card-icon card-icon-4">
                      <i class="iconfont iconzu3" />
                    </div>
                    <div class="card-text">我的订单</div>
                  </el-card>

                  <router-link
                    :to="reportShow ? '/report/index' : ''"
                    class="router-link-block"
                    v-if="employeeLevel && employeeLevel >= 40 && defaultBuType === '01' && employeeLevel !== 85"
                  >
                    <el-card shadow="hover" :class="reportShow ? '' : 'card-disabled'">
                      <div class="card-icon card-icon-6">
                        <i class="iconfont iconzu5" />
                      </div>
                      <div class="card-text">报表中心</div>
                    </el-card>
                  </router-link>

                  <router-link to="/gameplan/index" class="router-link-block">
                    <el-card shadow="hover">
                      <div class="card-icon card-icon-3">
                        <img src="../assets/images/bcc-order.png" />
                      </div>
                      <div class="card-text">GamePlan</div>
                    </el-card>
                  </router-link>

                  <el-card shadow="hover" @click.native="toIspIndex" v-if="canISPHigh">
                    <div class="card-icon card-icon-3">
                      <img src="../assets/images/isp-high.png" />
                    </div>
                    <div class="card-text">超高端项目</div>
                  </el-card>
                </template>
              </template>

              <template v-if="isBccProduct">
                <div @click="toBCCIndex" class="router-link-block">
                  <el-card shadow="hover">
                    <div class="card-icon card-icon-3">
                      <img src="../assets/images/bcc-order.png" />
                    </div>
                    <div class="card-text">订单管理</div>
                  </el-card>
                </div>

                <router-link to="/bcc/material/list" class="router-link-block">
                  <el-card shadow="hover">
                    <div class="card-icon card-icon-3">
                      <img src="../assets/images/bcc-material.png" />
                    </div>
                    <div class="card-text">物料管理</div>
                  </el-card>
                </router-link>

                <router-link to="/bcc/user/list" class="router-link-block">
                  <el-card shadow="hover">
                    <div class="card-icon card-icon-3">
                      <img src="../assets/images/bcc-user.png" />
                    </div>
                    <div class="card-text">人员账号管理</div>
                  </el-card>
                </router-link>
              </template>

              <template v-if="isAdmin">
                <el-card shadow="hover" @click.native="handleIcircle">
                  <div class="card-icon card-icon-3">
                    <img style="width: 100%; height: 100%" src="../assets/images/icircle.png" />
                  </div>
                  <div class="card-text">尊享先锋项目</div>
                </el-card>
              </template>
            </div>
          </el-col>

          <el-col :span="17" class="content-right"  v-if="isBccRechargeAccount">
            <el-col :sapn="24" class="content-right-row" >
            <el-card shadow="hover" @click.native="handleIcircle">
                <div class="card-icon card-icon-3">
                  <img style="width: 100%; height: 100%" src="../assets/images/icircle.png" />
                </div>
                <div class="card-text">尊享先锋项目</div>
              </el-card>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>

    <Footer :show-bg="true" />
    <Todo ref="shopsign-todo" content="店招制作模块暂未上线，请前往SRM系统进行店招申请。" />
    <NoticeContent ref="notice-content" />

    <v-form ref="sso-form" :url="ssoUrl" :params="ssoParam" param-mode="field" :with-token="false" />

    <el-dialog
      title="提示"
      :visible.sync="clientInfoErrorDialog"
      width="650px"
      custom-class="error-dialog"
    >
      <div class="error-message" v-for="item in clientInfoErrorMessage" :key="item">
        {{ item }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="btn-red-plain" @click="handleOptions">去处理</el-button>
        <el-button size="small" class="btn-red" @click="clientInfoErrorDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="人员问题处理"
      :visible.sync="optionsDialog"
      width="650px"
      top="8vh"
      custom-class="error-dialog info-error-dialog"
    >
      <div>
        <el-collapse v-model="activeNames">
          <el-collapse-item v-for="item in clientHandlerOptions" :key="item.name" :title="item.title" :name="item.name">
            <div style="color: #666" v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from './layout/components/header'
import Footer from './layout/components/footer'
import NoticeContent from './user/components/notice-content'
import Todo from '@/components/todo'
import vForm from '@/components/v-form'

import userApi from '@/api/user'
import coolerApi from '@/api/cooler'

import { mapGetters } from 'vuex'
import { commonUtils } from '@/utils/common'
import { parseTime } from '@/filters'
import { localStorageUtils } from "@/utils/localstorage"

import { clientHandlerOptions } from '@/constants'
export default {
  name: 'home',
  components: {
    Header,
    Footer,
    NoticeContent,
    Todo,
    vForm
  },
  data() {
    return {
      noticeList: [],
      entityList: [],
      reportShow: false,
      userName: '',
      dialogVisible: false,
      defaultBuType: '',
      employeeLevel: '',
      entityId: '',
      ssoUrl: '',
      ssoParam: {
        ssoToken: ''
      },
      canBudget: false,

      // isEnterFromLogin: false,

      clientInfoErrorMessage: [],
      clientInfoErrorDialog: false,
      clientHandlerOptions: [],
      activeNames: [],
      optionsDialog: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    avatarUrl() {
      const defaultAvatar = require('../assets/images/default-avatar.png')
      return commonUtils.getImageUrl(this.userInfo.avatarImageUri, defaultAvatar)
    },
    canIcircle() {
      return this.userInfo.permissionCodeList && this.userInfo.permissionCodeList.length
    },
    canISPHigh() {
      return ['28063811', '28062577', '28077456', '28051023', '28070610'].includes(this.userInfo.employeeCode)
    },
    isBccProduct() {
      const { clientAuthorizationCodeList } = this.userInfo
      return clientAuthorizationCodeList && clientAuthorizationCodeList.includes('bcc:product-vendor:maint')
    },
    isAdmin() {
      const roleList = this.userInfo.finalSysBizRoleList ? this.userInfo.finalSysBizRoleList.map(role => role.roleCode) : []
      return roleList.includes('super_admin') || roleList.includes('common_admin')
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     vm.isEnterFromLogin = from.path === '/login'
  //   })
  // },
  created () {
    this.defaultBuType = this.userInfo.defaultBuType
    this.employeeLevel = this.userInfo.employeeLevel
    if (this.employeeLevel === 45 || this.employeeLevel === 50) {
      this.canBudget = true
    }

    this.userName = this.userInfo.clientName
    this.init()
  },
  mounted () {
    // if (this.isEnterFromLogin && !['370', '138', '172'].includes(this.userInfo.regionCode)) {
    //   this.getUserVerifyDialog()
    // }
  },
  methods: {
    init() {
      this.queryNoticeList()
      this.getReportShow()
      this.checkPwdExpireTime()
    },
    // 获取公告列表
    queryNoticeList() {
      const params = {
        noticeType: '01'
      }
      userApi.queryNoticeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.noticeList = res.data.resultData.noticeList
        }
      })
    },

    viewNotice(notice) {
      this.$refs['notice-content'].show(notice)
    },

    viewShopsign() {
      this.$refs['shopsign-todo'].show()
    },

    toNotice() {
      this.$router.push('/user/notice/list')
    },
    // tonewModel() {
    //   this.$router.push("/bcc");
    // },
    leadToCoolerPlus() {
      console.log('lead to cooler plus')
      coolerApi.getCoolerPlusSsoInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.ssoUrl = res.data.resultData.ssoUrl
          this.ssoParam.ssoToken = res.data.resultData.ssoToken
          this.$refs['sso-form'].submit()
        }
      })
    },
    // 是否展示报表管理
    // 拥有等级 && 等级大于等于40 && 默认是百威01
    getReportShow() {
      if (this.employeeLevel && this.employeeLevel >= 40 && this.defaultBuType === '01') {
        this.reportShow = true
      }
    },

    // trade首页
    toTradeIndex() {
      if (!this.employeeLevel || this.employeeLevel < 40) {
        return
      }
      this.$router.push('/trade/index')
    },
    // BCC首页 BCC人员才能看到项目管理模块和渠道管理模块
    toBCCIndex() {
      this.$router.push('/bcc')
    },
    // game 首页
    toGameIndex() {
      this.$router.push('/gameplan/index')
    },
    // isp超高端
    toIspIndex() {
      this.$router.push('/isp/index')
    },

    // 预算管理
    toBudgetIndex() {
      if (!this.canBudget) {
        return
      }
      this.$router.push('/budget/index')
    },

    // 验证密码过期时间
    checkPwdExpireTime() {
      if (!this.$store.state.user.isFromLoginPage) return
      const { pwdExpireTime } = this.userInfo
      if (!pwdExpireTime) return
      const currentTime = +new Date()
      let msg = ''
      if (pwdExpireTime - currentTime > 0 && pwdExpireTime - currentTime < 1000 * 60 * 60 * 24 * 7) {
        msg = `您的密码将于${parseTime(pwdExpireTime, '{y}-{m}-{d}')}过期，请及时修改密码`
      } else {
        return
      }
      this.$notify({
        title: '提示',
        message: msg,
        type: 'warning',
        duration: 0
      })

      this.$store.commit('setLoginFrom', false)
    },

    // 尊享先锋项目
    handleIcircle () {
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning'
        })
      }

      const token = localStorageUtils.get('eb-token')
      const urlMap = {
        dev: 'https://icircle-dev.abipocm.com/login-auto',
        test: 'https://icircle-test.abipocm.com/login-auto',
        prod: 'https://icircle.abipocm.com/login-auto'
      }
      let url = urlMap[process.env.VUE_APP_ENV]
      if (!url) {
        return
      }
      window.location.href = `${url}?token=${token}&targetUri=/trade/index`
    },

    // pocm订购
    async handlePocm (router) {
      try {
        const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
        const dataParams = {
          cacheKey: 'pocmShow'
        }
        const { data } = await this.$store.dispatch('checkIcircleStatus', dataParams)
        if (data.resultCode === '0') {
          const { icircleShow } = data.resultData
          if (icircleShow != 1 || !inUse) {
            this.$router.push(router)
            return
          }

          const token = localStorageUtils.get('eb-token')
          const urlMap = {
            dev: 'https://icircle-dev.abipocm.com/login-auto',
            test: 'https://icircle-test.abipocm.com/login-auto',
            prod: 'https://icircle.abipocm.com/login-auto'
          }
          let url = urlMap[process.env.VUE_APP_ENV]
          if (!url) {
            return
          }
          window.location.href = `${url}?token=${token}&targetUri=${router}`
        }
      } catch (error) {
        this.$router.push(router)
      }
    },

    getUserVerifyDialog() {
      const metaErrors = JSON.parse(localStorageUtils.get('metaErrors'))
      let rtmHandler = [], apacHandler = [] 
      const rtmMap = {
        NO_MP_POST: '岗位',
        NO_MP_ORG: '组织架构',
        NO_MANAGER: '上级人员'
      }
      const apacMap = {
        NO_IDENTITY: '身份',
        EMPTY_ORG: '默认架构',
        NO_MP_USER: '主数据'
      }
      if (metaErrors?.length) {
        metaErrors.forEach(({ code }) => {
          if (rtmMap[code]) {
            rtmHandler.push(rtmMap[code])
          } else if (apacMap[code]) {
            apacHandler.push(apacMap[code])
          }
        })
      }
      if (rtmHandler.length) {
        this.clientInfoErrorMessage.push(`您的${rtmHandler.join('/')}信息缺失，请联系RTM维护`)
      }
      if (apacHandler.length) {
        this.clientInfoErrorMessage.push(`您的${apacHandler.join('/')}信息缺失，请联系APAC运营进行信息补充，以免影响操作`)
      }

      this.clientInfoErrorDialog = !!this.clientInfoErrorMessage.length
    },

    handleOptions() {
      const metaErrors = JSON.parse(localStorageUtils.get('metaErrors'))
      this.clientInfoErrorDialog = false
      this.clientHandlerOptions = clientHandlerOptions
      this.activeNames = metaErrors.map(item => item.code)
      this.optionsDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.marginLeft {
  margin-left: 15px;
}
.page {
  height: 100%;
}
.header-row {
  height: 10px;
  background-color: $base-red;
}

// .router-link-block {
//   display: inline-block;
//   height: 259px;
//   margin-bottom: 30px;
//   // margin-left:15px;
//   // margin-right:15px;
// }
.home-content {
  width: 100%;
  box-sizing: border-box;
  background-color: #f3f5f9;
}
.content-header {
  height: 100px;
  background: url('../assets/images/banner-home.jpg') center no-repeat;
  background-size: cover;
}
.content-wrapper {
  min-height: calc(100vh - 300px) !important;
  // .content-left,
  // .content-right {
  // }
  padding-bottom: 10px;
  .content-left {
    padding-right: $content-middle;
    .el-card {
      height: 552px;
      opacity: 0.9;
      border: 0;
      .card-title {
        padding: 18px;
        font-size: $font-14;
      }
      .text-title {
        font-size: $font-14;
        color: $base-plain;
        margin-top: 25px;
        padding-bottom: 8px;
        margin-bottom: 15px;
        border-bottom: 1px solid $base-grey2;
        .iconzu31 {
          font-size: $font-16;
          color: $base-plain;
          padding-right: 6px;
        }
      }
    }
    .notice-title {
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 10px;
    }
    .notice-title:hover {
      color: $base-red;
    }
    .card-user {
      height: 120px;
      background-color: #c8102d;
      display: flex;
      align-items: center;
      .user-pic {
        width: 80px;
        height: 80px;
        margin-left: $content-large;
        margin-right: $content-large;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .user-info {
        color: $base-white;
        .user-name {
          font-size: $font-16;
          margin-bottom: 10px;
        }
        .user-opera {
          font-size: $font-12;
          color: $base-white;
        }
      }
    }
  }
  .content-right {
    padding-left: $content-middle;
    .content-right-row {
      display: flex;
      flex-wrap: wrap;
      margin-left: -15px;
      .el-card {
        cursor: pointer;
        box-sizing: border-box;
        display: inline-block;
        width: 197px;
        height: 259px;
        opacity: 0.9;
        text-align: center;
        padding-top: 40px;
        margin-bottom: $content-large;
        margin-right: 15px;
        .card-icon {
          height: 85px;
          width: 85px;
          margin: auto;
          line-height: 85px;
          border-radius: 85px;
          margin-bottom: 25px;
          .iconfont {
            font-size: 40px;
            color: #fff;
          }
        }
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          text-decoration: none !important;
        }
        .card-text {
          font-size: $font-16;
          color: #000;
        }
      }
      .el-card:nth-child(2) {
        // margin-left: $content-middle;
        margin-right: $content-middle;
      }
    }
  }
  .home-btn {
    text-align: center;
    div {
      display: inline-block;
      width: 160px;
      height: 40px;
      border-radius: 20px;
      text-align: center;
      line-height: 42px;
      background-color: #dee2ed;
      margin: 0 $content-middle;
      a {
        text-decoration: none;
        color: #000;
      }
    }
    div:hover {
      background-color: $base-red;
      a {
        color: $base-white;
      }
    }
  }
}
.item-btn {
  padding-top: 30px;
  text-align: center;
}
.dialog-content {
  width: 380px;
  margin: auto;
}

.icon-volume-up {
  padding-right: 8px;
}
.card-icon {
  img {
    width: 85px;
    height: 85px;
  }
}
.card-icon-1 {
  background-color: $base-red;
}
.card-icon-2 {
  background-color: $base-pink;
}
.card-icon-3 {
  background-color: $base-yellow;
}
.card-icon-4 {
  background-color: $base-blue;
}
.card-icon-5 {
  background-color: $base-brown;
}
.card-icon-6 {
  background-color: $base-violet;
}
.icondian {
  color: #777777;
  padding-right: 5px;
}
.card-text > div {
  margin-top: 10px;
  padding-left: 18px;
  font-size: $font-14;
}

::v-deep .el-collapse-item__header {
  font-weight: bold;
  font-size: 14px;
}
.error-message {
  color: $base-red;
}
.error-message + .error-message {
  margin-top: 15px;
}
</style>
